// demoData.js
export const demoResources = [
    // ========== PERSONNEL (5 ресурсов) ==========
    {
        id: "agent.personnel.1",
        title: "Оператор Иванов",
        type: "personnel",
        status: 1,
        okp: "990001",
        segments: [
            {
                label: "Смена 1",
                dateStart: new Date(Date.now() - 86400000 - 10800000).toISOString(), // позавчера 21:00
                dateEnd: new Date(Date.now() - 86400000 - 3600000).toISOString(), // позавчера 23:00
                employee: "Иванов И.И.",
                agentId: "agent.personnel.1",
                status: 1,
                operationId: "op-personnel-001",
                operationNumber: "P001",
                operationStatus: 1,
                inOperationId: "inop-personnel-001"
            },
            {
                label: "Смена 2",
                dateStart: new Date(Date.now() - 3600000).toISOString(), // час назад
                dateEnd: new Date(Date.now() + 3600000).toISOString(), // через час
                employee: "Иванов И.И.",
                agentId: "agent.personnel.1",
                status: 1,
                operationId: "op-personnel-002",
                operationNumber: "P002",
                operationStatus: 3,
                inOperationId: "inop-personnel-002"
            },
            {
                label: "Смена 3",
                dateStart: new Date(Date.now() + 86400000 + 7200000).toISOString(), // завтра +2 часа
                dateEnd: new Date(Date.now() + 86400000 + 21600000).toISOString(), // завтра +6 часов
                employee: "Иванов И.И.",
                agentId: "agent.personnel.1",
                status: 1,
                operationId: "op-personnel-003",
                operationNumber: "P003",
                operationStatus: 2,
                inOperationId: "inop-personnel-003"
            }
        ]
    },
    {
        id: "agent.personnel.2",
        title: "Оператор Петров",
        type: "personnel",
        status: 2,
        okp: "990002",
        segments: [
            {
                label: "Утренняя смена",
                dateStart: new Date(Date.now() - 86400000 + 21600000).toISOString(), // вчера 6:00
                dateEnd: new Date(Date.now() - 86400000 + 36000000).toISOString(), // вчера 10:00
                employee: "Петров П.П.",
                agentId: "agent.personnel.2",
                status: 2,
                operationId: "op-personnel-004",
                operationNumber: "P004",
                operationStatus: 2,
                inOperationId: "inop-personnel-004"
            },
            {
                label: "Вечерняя смена",
                dateStart: new Date(Date.now() + 7200000).toISOString(), // через 2 часа
                dateEnd: new Date(Date.now() + 21600000).toISOString(), // через 6 часов
                employee: "Петров П.П.",
                agentId: "agent.personnel.2",
                status: 2,
                operationId: "op-personnel-005",
                operationNumber: "P005",
                operationStatus: 4,
                inOperationId: "inop-personnel-005"
            }
        ]
    },
    {
        id: "agent.personnel.3",
        title: "Наладчик Сидоров",
        type: "personnel",
        status: 3,
        okp: "990003",
        segments: [
            {
                label: "Техобслуживание",
                dateStart: new Date(Date.now() - 43200000).toISOString(), // 12 часов назад
                dateEnd: new Date(Date.now() - 14400000).toISOString(), // 4 часа назад
                employee: "Сидоров С.С.",
                agentId: "agent.personnel.3",
                status: 3,
                operationId: "op-personnel-006",
                operationNumber: "P006",
                operationStatus: 5,
                inOperationId: "inop-personnel-006"
            },
            {
                label: "Ремонт",
                dateStart: new Date(Date.now() + 86400000 + 28800000).toISOString(), // завтра 8:00
                dateEnd: new Date(Date.now() + 86400000 + 43200000).toISOString(), // завтра 12:00
                employee: "Сидоров С.С.",
                agentId: "agent.personnel.3",
                status: 3,
                operationId: "op-personnel-007",
                operationNumber: "P007",
                operationStatus: 1,
                inOperationId: "inop-personnel-007"
            }
        ]
    },
    {
        id: "agent.personnel.4",
        title: "Контролёр Козлов",
        type: "personnel",
        status: 4,
        okp: "990004",
        segments: [
            {
                label: "Контроль качества",
                dateStart: new Date(Date.now() - 28800000).toISOString(), // 8 часов назад
                dateEnd: new Date(Date.now() + 14400000).toISOString(), // через 4 часа
                employee: "Козлов К.К.",
                agentId: "agent.personnel.4",
                status: 4,
                operationId: "op-personnel-008",
                operationNumber: "P008",
                operationStatus: 3,
                inOperationId: "inop-personnel-008"
            }
        ]
    },
    {
        id: "agent.personnel.5",
        title: "Инженер Новиков",
        type: "personnel",
        status: 5,
        okp: "990005",
        segments: [
            {
                label: "Проектирование",
                dateStart: new Date(Date.now() - 72000000).toISOString(), // 20 часов назад
                dateEnd: new Date(Date.now() - 36000000).toISOString(), // 10 часов назад
                employee: "Новиков Н.Н.",
                agentId: "agent.personnel.5",
                status: 5,
                operationId: "op-personnel-009",
                operationNumber: "P009",
                operationStatus: 6,
                inOperationId: "inop-personnel-009"
            },
            {
                label: "Оптимизация",
                dateStart: new Date(Date.now() + 172800000).toISOString(), // послезавтра
                dateEnd: new Date(Date.now() + 172800000 + 14400000).toISOString(), // послезавтра +4 часа
                employee: "Новиков Н.Н.",
                agentId: "agent.personnel.5",
                status: 5,
                operationId: "op-personnel-010",
                operationNumber: "P010",
                operationStatus: 2,
                inOperationId: "inop-personnel-010"
            }
        ]
    },

    // ========== EQUIPMENT (5 ресурсов) ==========
    {
        id: "agent.equipment.1",
        title: "Токарный станок ЧПУ",
        type: "equipment",
        status: 1,
        okp: "120001",
        segments: [
            {
                label: "Деталь А001",
                dateStart: new Date(Date.now() - 86400000 * 2 + 28800000).toISOString(), // 2 дня назад 8:00
                dateEnd: new Date(Date.now() - 86400000 * 2 + 57600000).toISOString(), // 2 дня назад 16:00
                employee: "Иванов И.И.",
                agentId: "agent.equipment.1",
                status: 1,
                operationId: "op-equipment-001",
                operationNumber: "E001",
                operationStatus: 1,
                inOperationId: "inop-equipment-001"
            },
            // Пропуск 1 день
            {
                label: "Деталь А002",
                dateStart: new Date(Date.now() + 28800000).toISOString(), // сегодня 8:00
                dateEnd: new Date(Date.now() + 57600000).toISOString(), // сегодня 16:00
                employee: "Петров П.П.",
                agentId: "agent.equipment.1",
                status: 1,
                operationId: "op-equipment-002",
                operationNumber: "E002",
                operationStatus: 3,
                inOperationId: "inop-equipment-002"
            },
            // Пропуск 1 день
            {
                label: "Деталь А003",
                dateStart: new Date(Date.now() + 86400000 * 2 + 28800000).toISOString(), // через 2 дня 8:00
                dateEnd: new Date(Date.now() + 86400000 * 2 + 57600000).toISOString(), // через 2 дня 16:00
                employee: "Сидоров С.С.",
                agentId: "agent.equipment.1",
                status: 1,
                operationId: "op-equipment-003",
                operationNumber: "E003",
                operationStatus: 2,
                inOperationId: "inop-equipment-003"
            }
        ]
    },
    {
        id: "agent.equipment.2",
        title: "Фрезерный станок",
        type: "equipment",
        status: 2,
        okp: "120002",
        segments: [
            {
                label: "Заготовка Б001",
                dateStart: new Date(Date.now() - 86400000 * 3 + 36000000).toISOString(), // 3 дня назад 10:00
                dateEnd: new Date(Date.now() - 86400000 * 3 + 61200000).toISOString(), // 3 дня назад 17:00
                employee: "Козлов К.К.",
                agentId: "agent.equipment.2",
                status: 2,
                operationId: "op-equipment-004",
                operationNumber: "E004",
                operationStatus: 4,
                inOperationId: "inop-equipment-004"
            },
            // Пропуск 1 день
            {
                label: "Заготовка Б002",
                dateStart: new Date(Date.now() - 86400000 + 36000000).toISOString(), // вчера 10:00
                dateEnd: new Date(Date.now() - 86400000 + 61200000).toISOString(), // вчера 17:00
                employee: "Новиков Н.Н.",
                agentId: "agent.equipment.2",
                status: 2,
                operationId: "op-equipment-005",
                operationNumber: "E005",
                operationStatus: 5,
                inOperationId: "inop-equipment-005"
            },
            // Пропуск 1 день
            {
                label: "Заготовка Б003",
                dateStart: new Date(Date.now() + 86400000 + 36000000).toISOString(), // завтра 10:00
                dateEnd: new Date(Date.now() + 86400000 + 61200000).toISOString(), // завтра 17:00
                employee: "Иванов И.И.",
                agentId: "agent.equipment.2",
                status: 2,
                operationId: "op-equipment-006",
                operationNumber: "E006",
                operationStatus: 1,
                inOperationId: "inop-equipment-006"
            }
        ]
    },
    {
        id: "agent.equipment.3",
        title: "Шлифовальный станок",
        type: "equipment",
        status: 3,
        okp: "120003",
        segments: [
            {
                label: "Деталь В001",
                dateStart: new Date(Date.now() - 43200000).toISOString(), // 12 часов назад
                dateEnd: new Date(Date.now() + 14400000).toISOString(), // через 4 часа
                employee: "Петров П.П.",
                agentId: "agent.equipment.3",
                status: 3,
                operationId: "op-equipment-007",
                operationNumber: "E007",
                operationStatus: 6,
                inOperationId: "inop-equipment-007"
            },
            // Пропуск 1 день
            {
                label: "Деталь В002",
                dateStart: new Date(Date.now() + 86400000 + 43200000).toISOString(), // завтра 12:00
                dateEnd: new Date(Date.now() + 86400000 + 72000000).toISOString(), // завтра 20:00
                employee: "Сидоров С.С.",
                agentId: "agent.equipment.3",
                status: 3,
                operationId: "op-equipment-008",
                operationNumber: "E008",
                operationStatus: 2,
                inOperationId: "inop-equipment-008"
            }
        ]
    },
    {
        id: "agent.equipment.4",
        title: "Сверлильный станок",
        type: "equipment",
        status: 4,
        okp: "120004",
        segments: [
            {
                label: "Деталь Г001",
                dateStart: new Date(Date.now() - 86400000 * 4).toISOString(), // 4 дня назад
                dateEnd: new Date(Date.now() - 86400000 * 4 + 28800000).toISOString(), // 4 дня назад +8 часов
                employee: "Козлов К.К.",
                agentId: "agent.equipment.4",
                status: 4,
                operationId: "op-equipment-009",
                operationNumber: "E009",
                operationStatus: 3,
                inOperationId: "inop-equipment-009"
            },
            // Пропуск 1 день
            {
                label: "Деталь Г002",
                dateStart: new Date(Date.now() - 86400000 * 2).toISOString(), // 2 дня назад
                dateEnd: new Date(Date.now() - 86400000 * 2 + 28800000).toISOString(), // 2 дня назад +8 часов
                employee: "Новиков Н.Н.",
                agentId: "agent.equipment.4",
                status: 4,
                operationId: "op-equipment-010",
                operationNumber: "E010",
                operationStatus: 4,
                inOperationId: "inop-equipment-010"
            },
            // Пропуск 1 день
            {
                label: "Деталь Г003",
                dateStart: new Date(Date.now()).toISOString(), // сегодня
                dateEnd: new Date(Date.now() + 28800000).toISOString(), // сегодня +8 часов
                employee: "Иванов И.И.",
                agentId: "agent.equipment.4",
                status: 4,
                operationId: "op-equipment-011",
                operationNumber: "E011",
                operationStatus: 5,
                inOperationId: "inop-equipment-011"
            }
        ]
    },
    {
        id: "agent.equipment.5",
        title: "Пресс",
        type: "equipment",
        status: 5,
        okp: "120005",
        segments: [
            {
                label: "Штамповка Д001",
                dateStart: new Date(Date.now() - 86400000 * 5 + 54000000).toISOString(), // 5 дней назад 15:00
                dateEnd: new Date(Date.now() - 86400000 * 5 + 75600000).toISOString(), // 5 дней назад 21:00
                employee: "Петров П.П.",
                agentId: "agent.equipment.5",
                status: 5,
                operationId: "op-equipment-012",
                operationNumber: "E012",
                operationStatus: 1,
                inOperationId: "inop-equipment-012"
            },
            // Пропуск 1 день
            {
                label: "Штамповка Д002",
                dateStart: new Date(Date.now() - 86400000 * 3 + 54000000).toISOString(), // 3 дня назад 15:00
                dateEnd: new Date(Date.now() - 86400000 * 3 + 75600000).toISOString(), // 3 дня назад 21:00
                employee: "Сидоров С.С.",
                agentId: "agent.equipment.5",
                status: 5,
                operationId: "op-equipment-013",
                operationNumber: "E013",
                operationStatus: 2,
                inOperationId: "inop-equipment-013"
            },
            // Пропуск 1 день
            {
                label: "Штамповка Д003",
                dateStart: new Date(Date.now() - 86400000 + 54000000).toISOString(), // вчера 15:00
                dateEnd: new Date(Date.now() - 86400000 + 75600000).toISOString(), // вчера 21:00
                employee: "Козлов К.К.",
                agentId: "agent.equipment.5",
                status: 5,
                operationId: "op-equipment-014",
                operationNumber: "E014",
                operationStatus: 3,
                inOperationId: "inop-equipment-014"
            }
        ]
    },

    // ========== tool (5 ресурсов) ==========
    {
        id: "agent.tool.1",
        title: "Измерительный комплекс",
        type: "tool",
        status: 1,
        okp: "880001",
        segments: [
            {
                label: "Калибровка",
                dateStart: new Date(Date.now() - 86400000 * 6).toISOString(), // 6 дней назад
                dateEnd: new Date(Date.now() - 86400000 * 6 + 18000000).toISOString(), // 6 дней назад +5 часов
                employee: "Новиков Н.Н.",
                agentId: "agent.tool.1",
                status: 1,
                operationId: "op-tool-001",
                operationNumber: "T001",
                operationStatus: 1,
                inOperationId: "inop-tool-001"
            },
            // Пропуск 1 день
            {
                label: "Проверка точности",
                dateStart: new Date(Date.now() - 86400000 * 4).toISOString(), // 4 дня назад
                dateEnd: new Date(Date.now() - 86400000 * 4 + 18000000).toISOString(), // 4 дня назад +5 часов
                employee: "Иванов И.И.",
                agentId: "agent.tool.1",
                status: 1,
                operationId: "op-tool-002",
                operationNumber: "T002",
                operationStatus: 2,
                inOperationId: "inop-tool-002"
            },
            // Пропуск 1 день
            {
                label: "Тестирование",
                dateStart: new Date(Date.now() - 86400000 * 2).toISOString(), // 2 дня назад
                dateEnd: new Date(Date.now() - 86400000 * 2 + 18000000).toISOString(), // 2 дня назад +5 часов
                employee: "Петров П.П.",
                agentId: "agent.tool.1",
                status: 1,
                operationId: "op-tool-003",
                operationNumber: "T003",
                operationStatus: 3,
                inOperationId: "inop-tool-003"
            }
        ]
    },
    {
        id: "agent.tool.2",
        title: "Набор инструментов №1",
        type: "tool",
        status: 2,
        okp: "880002",
        segments: [
            {
                label: "Техобслуживание",
                dateStart: new Date(Date.now() - 86400000 * 7 + 64800000).toISOString(), // 7 дней назад 18:00
                dateEnd: new Date(Date.now() - 86400000 * 7 + 79200000).toISOString(), // 7 дней назад 22:00
                employee: "Сидоров С.С.",
                agentId: "agent.tool.2",
                status: 2,
                operationId: "op-tool-004",
                operationNumber: "T004",
                operationStatus: 4,
                inOperationId: "inop-tool-004"
            },
            // Пропуск 1 день
            {
                label: "Заточка",
                dateStart: new Date(Date.now() - 86400000 * 5 + 64800000).toISOString(), // 5 дней назад 18:00
                dateEnd: new Date(Date.now() - 86400000 * 5 + 79200000).toISOString(), // 5 дней назад 22:00
                employee: "Козлов К.К.",
                agentId: "agent.tool.2",
                status: 2,
                operationId: "op-tool-005",
                operationNumber: "T005",
                operationStatus: 5,
                inOperationId: "inop-tool-005"
            },
            // Пропуск 1 день
            {
                label: "Проверка",
                dateStart: new Date(Date.now() - 86400000 * 3 + 64800000).toISOString(), // 3 дня назад 18:00
                dateEnd: new Date(Date.now() - 86400000 * 3 + 79200000).toISOString(), // 3 дня назад 22:00
                employee: "Новиков Н.Н.",
                agentId: "agent.tool.2",
                status: 2,
                operationId: "op-tool-006",
                operationNumber: "T006",
                operationStatus: 6,
                inOperationId: "inop-tool-006"
            }
        ]
    },
    {
        id: "agent.tool.3",
        title: "Контрольный стенд",
        type: "tool",
        status: 3,
        okp: "880003",
        segments: [
            {
                label: "Диагностика",
                dateStart: new Date(Date.now() - 86400000 * 8 + 46800000).toISOString(), // 8 дней назад 13:00
                dateEnd: new Date(Date.now() - 86400000 * 8 + 61200000).toISOString(), // 8 дней назад 17:00
                employee: "Иванов И.И.",
                agentId: "agent.tool.3",
                status: 3,
                operationId: "op-tool-007",
                operationNumber: "T007",
                operationStatus: 1,
                inOperationId: "inop-tool-007"
            },
            // Пропуск 1 день
            {
                label: "Тестирование модулей",
                dateStart: new Date(Date.now() - 86400000 * 6 + 46800000).toISOString(), // 6 дней назад 13:00
                dateEnd: new Date(Date.now() - 86400000 * 6 + 61200000).toISOString(), // 6 дней назад 17:00
                employee: "Петров П.П.",
                agentId: "agent.tool.3",
                status: 3,
                operationId: "op-tool-008",
                operationNumber: "T008",
                operationStatus: 2,
                inOperationId: "inop-tool-008"
            }
        ]
    },
    {
        id: "agent.tool.4",
        title: "Анализатор качества",
        type: "tool",
        status: 4,
        okp: "880004",
        segments: [
            {
                label: "Анализ образцов",
                dateStart: new Date(Date.now() - 86400000 * 9 + 75600000).toISOString(), // 9 дней назад 21:00
                dateEnd: new Date(Date.now() - 86400000 * 9 + 86400000).toISOString(), // 9 дней назад 24:00
                employee: "Сидоров С.С.",
                agentId: "agent.tool.4",
                status: 4,
                operationId: "op-tool-009",
                operationNumber: "T009",
                operationStatus: 3,
                inOperationId: "inop-tool-009"
            },
            // Пропуск 1 день
            {
                label: "Калибровка датчиков",
                dateStart: new Date(Date.now() - 86400000 * 7 + 75600000).toISOString(), // 7 дней назад 21:00
                dateEnd: new Date(Date.now() - 86400000 * 7 + 86400000).toISOString(), // 7 дней назад 24:00
                employee: "Козлов К.К.",
                agentId: "agent.tool.4",
                status: 4,
                operationId: "op-tool-010",
                operationNumber: "T010",
                operationStatus: 4,
                inOperationId: "inop-tool-010"
            },
            // Пропуск 1 день
            {
                label: "Тест на точность",
                dateStart: new Date(Date.now() - 86400000 * 5 + 75600000).toISOString(), // 5 дней назад 21:00
                dateEnd: new Date(Date.now() - 86400000 * 5 + 86400000).toISOString(), // 5 дней назад 24:00
                employee: "Новиков Н.Н.",
                agentId: "agent.tool.4",
                status: 4,
                operationId: "op-tool-011",
                operationNumber: "T011",
                operationStatus: 5,
                inOperationId: "inop-tool-011"
            }
        ]
    },
    {
        id: "agent.tool.5",
        title: "Универсальный стенд",
        type: "tool",
        status: 5,
        okp: "880005",
        segments: [
            {
                label: "Настройка",
                dateStart: new Date(Date.now() - 86400000 * 10 + 32400000).toISOString(), // 10 дней назад 9:00
                dateEnd: new Date(Date.now() - 86400000 * 10 + 50400000).toISOString(), // 10 дней назад 14:00
                employee: "Иванов И.И.",
                agentId: "agent.tool.5",
                status: 5,
                operationId: "op-tool-012",
                operationNumber: "T012",
                operationStatus: 6,
                inOperationId: "inop-tool-012"
            },
            // Пропуск 1 день
            {
                label: "Верификация",
                dateStart: new Date(Date.now() - 86400000 * 8 + 32400000).toISOString(), // 8 дней назад 9:00
                dateEnd: new Date(Date.now() - 86400000 * 8 + 50400000).toISOString(), // 8 дней назад 14:00
                employee: "Петров П.П.",
                agentId: "agent.tool.5",
                status: 5,
                operationId: "op-tool-013",
                operationNumber: "T013",
                operationStatus: 1,
                inOperationId: "inop-tool-013"
            },
            // Пропуск 1 день
            {
                label: "Финальные тесты",
                dateStart: new Date(Date.now() - 86400000 * 6 + 32400000).toISOString(), // 6 дней назад 9:00
                dateEnd: new Date(Date.now() - 86400000 * 6 + 50400000).toISOString(), // 6 дней назад 14:00
                employee: "Сидоров С.С.",
                agentId: "agent.tool.5",
                status: 5,
                operationId: "op-tool-014",
                operationNumber: "T014",
                operationStatus: 2,
                inOperationId: "inop-tool-014"
            }
        ]
    }
];

export const demoOperations = [
    // Операции для Personnel
    ...demoResources
        .filter(r => r.type === "personnel")
        .flatMap(resource =>
            resource.segments.map(segment => ({
                id: segment.operationId,
                title: segment.label,
                startDate: new Date(segment.dateStart),
                endDate: new Date(segment.dateEnd),
                resourceId: resource.id,
                color: getColorByStatus(segment.operationStatus),
                status: segment.operationStatus,
                inOperationId: segment.inOperationId
            }))
        ),

    // Операции для Equipment
    ...demoResources
        .filter(r => r.type === "equipment")
        .flatMap(resource =>
            resource.segments.map(segment => ({
                id: segment.operationId,
                title: segment.label,
                startDate: new Date(segment.dateStart),
                endDate: new Date(segment.dateEnd),
                resourceId: resource.id,
                color: getColorByStatus(segment.operationStatus),
                status: segment.operationStatus,
                inOperationId: segment.inOperationId
            }))
        ),

    // Операции для tool
    ...demoResources
        .filter(r => r.type === "tool")
        .flatMap(resource =>
            resource.segments.map(segment => ({
                id: segment.operationId,
                title: segment.label,
                startDate: new Date(segment.dateStart),
                endDate: new Date(segment.dateEnd),
                resourceId: resource.id,
                color: getColorByStatus(segment.operationStatus),
                status: segment.operationStatus,
                inOperationId: segment.inOperationId
            }))
        )
];

export const demoParameters = [
    {
        parameterId: "param-equipment-001",
        parameterBody: JSON.stringify({
            temperature: 25.5,
            pressure: 1.2,
            speed: 1500,
            status: "normal",
            details: {
                coolant: true,
                lubrication: "optimal",
                vibration: "low",
                powerConsumption: "220V",
                operatingHours: 1560
            }
        })
    },
    {
        parameterId: "param-personnel-001",
        parameterBody: JSON.stringify({
            employee: "Иванов И.И.",
            position: "Оператор станков",
            qualification: "5 разряд",
            currentTask: "Токарная обработка",
            performance: 95,
            details: {
                safetyScore: 98,
                qualityScore: 92,
                efficiencyScore: 96
            }
        })
    },
    {
        parameterId: "param-tool-001",
        parameterBody: JSON.stringify({
            toolName: "Измерительный комплекс",
            calibrationDate: new Date(Date.now() - 86400000 * 30).toISOString(),
            accuracy: 0.001,
            status: "calibrated",
            details: {
                lastMaintenance: new Date(Date.now() - 86400000 * 7).toISOString(),
                batteryLevel: 87,
                sensorStatus: "active"
            }
        })
    }
];

// Вспомогательная функция для определения цвета по статусу
function getColorByStatus(status) {
    const statusNumber = Number(status);
    switch (statusNumber) {
        case 1: return "rgb(50, 205, 50)";   // зеленый - выполнено
        case 2: return "rgb(128, 128, 128)"; // серый - в ожидании
        case 3: return "rgb(255, 165, 0)";   // оранжевый - в процессе
        case 4: return "rgb(255, 0, 0)";     // красный - ошибка
        case 5: return "rgb(255, 255, 0)";   // желтый - на паузе
        case 6: return "rgb(0, 0, 255)";     // синий - планируется
        case 7: return "rgb(128, 0, 128)";   // фиолетовый - отменено
        default: return "rgb(128, 128, 128)";
    }
}